import axios from 'axios'

export const CUSTOMER_URL = `${process.env.REACT_APP_API_URL}/CustomerDetails`;

export const getCustomerDetailsByEmail = async (
  email: string
) => {
  try {
    const response = await axios.get(`${CUSTOMER_URL}/getcustomerbyemail`, {
      params: {
        email
      }
    })
    return response.data
  } catch (err) {
    return err
  }
}